import React from 'react';
import { useTranslation } from 'react-i18next';

export interface SteamGameImportEfficiencyCardProps {
  timeSavedMinutes: number;
  gamesCount: number;
  skusCount: number;
}

function SteamGameImportEfficiencyCard({
  timeSavedMinutes,
  gamesCount,
  skusCount,
}: SteamGameImportEfficiencyCardProps) {
  const { t } = useTranslation();

  return (
    <div className="card glass-panel glow-cyan p-4 mb-3 text-center flex-shrink-0">
      <div className="small text-uppercase tracking-wider text-secondary mb-2">
        {t('Efficiency Gain')}
      </div>
      <div className="display-3 fw-bold text-blue mb-1">
        {timeSavedMinutes}m
      </div>
      <div className="small text-secondary mb-4">
        {t('Total Manual Labor Eliminated')}
      </div>

      <hr className="opacity-10" />

      <div className="row mt-3">
        <div className="col-6">
          <div className="h4 mb-0 fw-bold">{gamesCount}</div>
          <div className="small text-secondary">{t('Entities')}</div>
        </div>
        <div className="col-6">
          <div className="h4 mb-0 fw-bold">{skusCount}</div>
          <div className="small text-secondary">{t('SKU Records')}</div>
        </div>
      </div>
    </div>
  );
}

export default SteamGameImportEfficiencyCard;
